import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  float: left;
  margin-bottom: 1px;

  @media (max-width: 1024px) {
  }
`;

export const Control = styled.div`
  width: 100%;
  float: left;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 60px;
  cursor: pointer;
  padding: 0 10px;
  background: rgba(255,255,255,0.05);
  transition: all 0.5s ease;

  &:hover {
    text-decoration: underline;
  }

  @media (max-width: 1024px) {
  }
`;

export const Title = styled.div`
  color: #fff;
  flex: 1;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  display: flex;

  @media (max-width: 1024px) {
  }
`;

export const Right = styled.div`
  @media (max-width: 1024px) {
  }
`;

export const Content = styled.div`
  width: 100%;
  float: left;
  border-left: 5px solid rgba(255,255,255,0.5);
`;
